// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetEmployeeProbationReviewTermQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetEmployeeProbationReviewTermQuery = { __typename?: 'Query' } & {
  employee: Types.Maybe<
    { __typename?: 'Employee' } & Pick<Types.Employee, 'id'> & {
        currentMainContract: Types.Maybe<
          { __typename?: 'EmployeeContract' } & Pick<Types.EmployeeContract, 'id'> & {
              company: { __typename?: 'Company' } & Pick<Types.Company, 'id'> & {
                  probationReviewTerm: { __typename?: 'CompanyProbationReviewTerm' } & Pick<
                    Types.CompanyProbationReviewTerm,
                    'length' | 'mode'
                  >;
                };
            }
        >;
      }
  >;
};

export const GetEmployeeProbationReviewTermDocument = /*#__PURE__*/ gql`
    query getEmployeeProbationReviewTerm($id: ID!) {
  employee(id: $id) {
    id
    currentMainContract {
      id
      company {
        id
        probationReviewTerm {
          length
          mode
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployeeProbationReviewTermQuery__
 *
 * To run a query within a React component, call `useGetEmployeeProbationReviewTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeProbationReviewTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeProbationReviewTermQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeProbationReviewTermQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeProbationReviewTermQuery,
    GetEmployeeProbationReviewTermQueryVariables
  > &
    ({ variables: GetEmployeeProbationReviewTermQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeProbationReviewTermQuery, GetEmployeeProbationReviewTermQueryVariables>(
    GetEmployeeProbationReviewTermDocument,
    options,
  );
}
export function useGetEmployeeProbationReviewTermLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeProbationReviewTermQuery,
    GetEmployeeProbationReviewTermQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeProbationReviewTermQuery, GetEmployeeProbationReviewTermQueryVariables>(
    GetEmployeeProbationReviewTermDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEmployeeProbationReviewTermSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEmployeeProbationReviewTermQuery,
    GetEmployeeProbationReviewTermQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEmployeeProbationReviewTermQuery, GetEmployeeProbationReviewTermQueryVariables>;
export function useGetEmployeeProbationReviewTermSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeProbationReviewTermQuery,
        GetEmployeeProbationReviewTermQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEmployeeProbationReviewTermQuery | undefined,
  GetEmployeeProbationReviewTermQueryVariables
>;
export function useGetEmployeeProbationReviewTermSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEmployeeProbationReviewTermQuery,
        GetEmployeeProbationReviewTermQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployeeProbationReviewTermQuery, GetEmployeeProbationReviewTermQueryVariables>(
    GetEmployeeProbationReviewTermDocument,
    options,
  );
}
export type GetEmployeeProbationReviewTermQueryHookResult = ReturnType<typeof useGetEmployeeProbationReviewTermQuery>;
export type GetEmployeeProbationReviewTermLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeProbationReviewTermLazyQuery
>;
export type GetEmployeeProbationReviewTermSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeProbationReviewTermSuspenseQuery
>;
